// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__0pr6t","copy":"style_copy__216bI","companyLogo":"style_companyLogo__JQrXI","wrapperWhitelabel":"style_wrapperWhitelabel__1utfb"};